import React, { FC } from "react";
import styles from "./styles.module.scss";

const ContentWrapper: FC = ({ children }) => {
  return <div className={styles.contentWrapper}>{children}</div>;
};

export default ContentWrapper;
